import { faCheckCircle } from '@document-crunch/pro-regular-svg-icons'

import { Icon } from '@dc-shared-web/components/base'

export default function NotificationInboxEmpty() {
  return (
    <div className='tw-grow tw-overflow-auto'>
      <div className='tw-pb-8 tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-[180px]'>
        <div className='tw-flex tw-items-center tw-py-2'>
          <Icon
            size='2xl'
            icon={faCheckCircle}
            className='tw-text-neutral-400'
          />
        </div>
        <div className='tw-flex tw-items-center'>
          <span className='tw-ml-2 tw-font-medium tw-text-lg'>
            You&apos;re all caught up
          </span>
        </div>
        <div className='tw-flex tw-items-center tw-w-[244px] tw-text-center'>
          <span className='tw-text-neutral-400'>
            You&apos;ll be notified here of any @ mentions, replies, or
            reactions
          </span>
        </div>
      </div>
    </div>
  )
}
